import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import AppLayout from '../../../components/layout/AppLayout.jsx';
import ChatContainer from '../../../components/chat/ChatContainer.jsx';
import Overview from './Overview.jsx';
import Documents from './Documents.jsx';
import Activity from './Activity.jsx';
import Investments from './Investments.jsx';
import ContributionChange from './ContributionChange.jsx';
import DistributionsPage from './DistributionsPage.jsx';
import BeneficiaryAndAddressPage from './BeneficiaryAndAddressPage.jsx';
import LoanPage from './LoanPage.jsx';
import HardshipPage from './HardshipPage.jsx';
import TaxGuidePage from './TaxGuidePage.jsx';
import ParticipantProfile from './ParticipantProfile.jsx';
import Settings from './Settings.jsx';

const HEADERS = {
  '':                   { title: 'Participant Actions',       subtitle: 'Everything available under your retirement plan' },
  chat:                 { title: 'Chat',                      subtitle: 'Ask about your account or start a request' },
  loans:                { title: 'Loans',                     subtitle: 'Borrow against your vested balance' },
  investments:          { title: 'Investment Reallocation',   subtitle: 'Change how your account is invested' },
  'contribution-change':{ title: 'Contribution Change',       subtitle: 'Adjust your payroll deferral rate' },
  'beneficiary-update': { title: 'Beneficiary & Address',     subtitle: 'Update your beneficiary designation or mailing address' },
  hardship:             { title: 'Hardship Withdrawal',       subtitle: 'Access funds early for a qualifying financial hardship' },
  distributions:        { title: 'Distributions',             subtitle: 'In-service, separation, RMD, or QDRO — choose your distribution type' },
  documents:            { title: 'Submitted Documents',       subtitle: "Status of documents you've uploaded" },
  activity:             { title: 'Activity History',          subtitle: 'Your transactions, decisions, and pending requests' },
  'tax-guide':          { title: 'Tax & Penalty Guide',       subtitle: 'How taxes and penalties flow for each transaction type' },
  profile:              { title: 'My Profile',                subtitle: 'Your account information and plan details' },
  settings:             { title: 'Account Settings',          subtitle: 'Manage your account security' },
};

export default function ParticipantDashboard() {
  const location = useLocation();
  const segment = location.pathname.replace(/^\/participant\/?/, '').split('/')[0] || '';
  const { title, subtitle } = HEADERS[segment] || HEADERS[''];

  return (
    <AppLayout variant="participant" title={title} subtitle={subtitle}>
      <Routes>
        <Route index element={<Overview />} />
        <Route path="chat" element={<ChatContainer />} />

        <Route path="loans" element={<LoanPage />} />

        <Route path="investments" element={<Investments />} />

        <Route path="contribution-change" element={<ContributionChange />} />

        <Route path="beneficiary-update" element={<BeneficiaryAndAddressPage />} />

        <Route path="hardship" element={<HardshipPage />} />

        <Route path="distributions" element={<DistributionsPage />} />

        <Route path="documents" element={<Documents />} />
        <Route path="activity" element={<Activity />} />
        <Route path="tax-guide" element={<TaxGuidePage />} />
        <Route path="profile" element={<ParticipantProfile />} />
        <Route path="settings" element={<Settings />} />
      </Routes>
    </AppLayout>
  );
}
